module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"page_title":"Ошибка","page_not_found":"Вы ищете страницу, которой не существует.","go_to":"Вы можете перейти на","main_page":"Главную страницу","server_error":"Ошибка сервера №"},"en":{"page_title":"Error","page_not_found":"The page you are looking for doesn\u0027t exist.","go_to":"You can go to the","main_page":"Home page","server_error":"Server error "}}')
  delete Component.options._Ctor
}
